var _g, _path, _circle, _circle2, _circle3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDrawPolyline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.69230769 0 0 .69230769 1.846154 1.846154)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#5a8c5a",
    height: 13,
    rx: 2.614937,
    width: 13,
    x: 19,
    y: 19
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.6 25.499999h7.8",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 29.399999v-7.799999",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3 25.499999h10.4s0 0 0-2.6c0-2.599999-.65-2.599999-5.2-2.599999s-5.2 0-5.2 2.599999z",
    fill: "#fcffff",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 8.5,
    style: {
      fill: "#2a7fff",
      stroke: "#333",
      strokeWidth: 1.001735,
      strokeLinejoin: "round",
      strokeMiterlimit: 0.4,
      strokeOpacity: 0.972549
    },
    transform: "matrix(.29411765 0 0 .29411762 -.029412 6.117648)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.7092162 5.3723515-1.4184324 4.255297",
    fill: "none",
    stroke: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#2a7fff",
      stroke: "#333",
      strokeWidth: 1.001735,
      strokeLinejoin: "round",
      strokeMiterlimit: 0.4,
      strokeOpacity: 0.972549
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 8.5,
    transform: "matrix(.29411765 0 0 .29411762 2.970588 -2.882352)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 8.5,
    transform: "matrix(.29411765 0 0 .29411762 16.970588 -1.882352)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 8.5,
    transform: "matrix(.29411765 0 0 .29411762 5.970588 15.117648)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.9937522 3.1781252 9.0124958.6437496",
    fill: "none",
    stroke: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.8868972 14.080346 3.2262057 4.839309",
    fill: "none",
    stroke: "#000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDrawPolyline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/draw_polyline.84bbdf2f.svg";
export { ForwardRef as ReactComponent };